import React from 'react';
import { Box, Typography, FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material';
import { useConfig } from '../../../../context/ConfigContext';

const ScottishResidentSelector = () => {
  const { isScottish, setIsScottish } = useConfig();

  const handleScottishChange = (event) => {
    setIsScottish(event.target.value === "yes");
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Are you a Scottish resident?
      </Typography>
      <FormControl component="fieldset">
      <RadioGroup row value={isScottish ? "yes" : "no"} onChange={handleScottishChange}>
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="no" control={<Radio />} label="No" />
      </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default ScottishResidentSelector;